export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Remove data URL prefix (e.g., "data:application/pdf;base64,")
      const base64 = reader.result?.toString().split(',')[1];
      if (base64) {
        resolve(base64);
      } else {
        reject(new Error('Failed to convert file to base64'));
      }
    };
    reader.onerror = (error) => reject(error);
  });
};

export const validateDocumentFile = (file: File): { valid: boolean; error?: string } => {
  const allowedExtensions = ['.docx', '.pdf', '.odt'];
  const extension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));

  if (!allowedExtensions.includes(extension)) {
    return { valid: false, error: 'Поддерживаются только форматы: DOCX, PDF, ODT' };
  }

  if (file.size > 16 * 1024 * 1024) { // 16MB
    return { valid: false, error: 'Размер файла не должен превышать 16MB' };
  }

  return { valid: true };
};